package com.shadowings.gero.domain.model

data class Message(
    val characters: Characters,
    val faces: Faces,
    val text: String
)

